import axios from 'axios';
import { Station, Report, CreateReportData, Stats, ActivityItem } from './types';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const stationsApi = {
  // Récupérer toutes les stations
  getAll: async (): Promise<Station[]> => {
    const response = await api.get('/stations');
    return response.data;
  },

  // Récupérer les signalements d'une station
  getReports: async (stationId: number, limit = 10): Promise<Report[]> => {
    const response = await api.get(`/stations/${stationId}/reports?limit=${limit}`);
    return response.data;
  },
};

export const reportsApi = {
  // Créer un nouveau signalement
  create: async (reportData: CreateReportData): Promise<Report> => {
    const response = await api.post('/reports', reportData);
    return response.data;
  },
};

export const statsApi = {
  // Récupérer les statistiques
  get: async (): Promise<Stats> => {
    const response = await api.get('/stats');
    return response.data;
  },
};

export const activityApi = {
  // Récupérer le flux d'activité (signalements récents)
  getRecent: async (limit = 20): Promise<ActivityItem[]> => {
    const response = await api.get(`/activity?limit=${limit}`);
    return response.data;
  },
};

// Gestion des erreurs globales
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Erreur API:', error);

    if (error.response?.status === 404) {
      throw new Error('Ressource non trouvée');
    } else if (error.response?.status === 500) {
      throw new Error('Erreur serveur. Veuillez réessayer.');
    } else if (error.code === 'NETWORK_ERROR') {
      throw new Error('Erreur de connexion. Vérifiez votre connexion internet.');
    }

    throw error;
  }
);

export default api;